import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { B2CConfig } from '@inside-hub-app/customer-portal-config'

import { AppModule } from './app/app.module'
const remoteConfig = (window as any).ef.remoteConfig.configuration as B2CConfig

if (remoteConfig.production) {
  enableProdMode()
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))

// insert analytics script
const script = document.createElement('script')
script.src =
  'https://www.googletagmanager.com/gtag/js?id=' +
  remoteConfig['googleAnalytics.id']
script.async = true
document.head.prepend(script)

// eslint-disable-next-line @typescript-eslint/dot-notation
window['dataLayer'] = window['dataLayer'] || []
// eslint-disable-next-line prefer-rest-params

// eslint-disable-next-line @typescript-eslint/dot-notation
function gtag(...args) {
  window['dataLayer'].push(arguments)
}
gtag('js', new Date())
gtag('config', remoteConfig['googleAnalytics.id'])

// google tag
/**
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
  var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
  j['async'] = true;
  j['src'] = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'googleTagDataLayer', env.googleTag.id);

const noscript = document.createElement('noscript');
const iframe = document.createElement('iframe');
iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + env.googleTag.id;
iframe.height = '0';
iframe.width = '0';
iframe.setAttribute('style', 'display:none;visibility:hidden');
noscript.append(iframe);
document.body.append(noscript);
*/
